<template>
  <div id="dash-controlsidebar">
    <aside :class="'control-sidebar control-sidebar-dark ' + controlsidebarOpen">
      <div class="tab-content">
        <div id="control-sidebar-theme-demo-options-tab">
          <div>
            <ul class="control-sidebar-menu">
              <li class="server-datetime clearfix">
                <div class="date"><i class="fa fa-calendar"></i> {{ date }}</div>
                <div class="time"><i class="fa fa-clock-o"></i> {{ time }}</div>
              </li>
              <li>
                <a @click="postLogout()" class="cursor-pointer">
                  <i class="menu-icon fa fa-power-off bg-gray-dark"></i>
                  <div class="menu-info info-without-detail">
                    <h4 class="control-sidebar-subheading">{{ logoutLabel }}</h4>
                  </div>
                </a>
              </li>
            </ul>
            <h3 class="control-sidebar-heading">Switch Language</h3>
            <ul class="control-sidebar-menu">
              <template v-for="(value, index) in allLang">
                <li :class="{ active: value === nowLang }" class="cursor-pointer">
                  <a @click="switchLang(value)" style="color:#FFF;">
                    <img class="img-language" :src="require('static/images/flag_' + focusLang(value) + '.png')" style="padding-left:0; width:30px; margin-right:-2px;">
                    <span class="language-label" :class="[ value === nowLang ? 'active' : '' ]">{{ descLang[index] }}</span>
                  </a>
                </li>
              </template>
            </ul>
            <h3 class="control-sidebar-heading">Get E-mail Language  <i class="fa fa-envelope"></i></h3>
            <form>
              <ul class="control-sidebar-menu">
                <template v-for="(value, index) in allLang">
                  <li :class="{ active: value === mailLang }" class="cursor-pointer" :key="index">
                    <a @click="setMailLang(value)" style="color:#FFF;">
                      <!-- <img class="img-language" :src="require('static/images/flag_' + focusMailLang(value) + '.png')" style="padding-left:0; width:30px; margin-right:-2px;"> -->
                      <input type="radio" name="emailLang" :value="value" :checked="value === mailLang">
                      <span class="language-label" :class="[ value === nowLang ? 'active' : '' ]">{{ descLang[index] }}</span>
                    </a>
                  </li>
                </template>
              </ul>
            </form>
            <br>
            <h4 class="control-sidebar-heading">Theme</h4>
            <div class="nav-tabs-theme">
              <ul class="nav nav-tabs">
                <li class="active" style="font-size: 12px;">
                  <a tabindex="-1" href="#dark_theme" class="cursor-pointer" data-toggle="tab">Dark Theme</a>
                </li>
                <li style="font-size: 12px;">
                  <a tabindex="-1" href="#light_theme" class="cursor-pointer" data-toggle="tab">Light Theme</a>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="dark_theme">
                  <ul class="list-unstyled clearfix">
                    <template v-for="colorSkin in colorSkins">
                      <li style="float:left; width: 50%; height:auto; padding: 5px;">
                        <a tabindex="-1" href="javascript:void(0);" :data-skin="'skin-'+colorSkin" style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                          <div>
                            <span style="display:block; width: 20%; float: left; height: 10px;" :class="'bg-'+colorSkin+'-active'"></span>
                            <span :class="'bg-'+colorSkin" style="display:block; width: 80%; float: left; height: 10px;"></span>
                          </div>
                          <div>
                            <span style="display:block; width: 20%; float: left; height: 35px;" :style="{ background: colorLeftSidebarDark }"></span>
                            <span style="display:block; width: 80%; float: left; height: 35px;" :style="{ background: colorBodySidebarDark }"></span>
                          </div>
                        </a>
                        <p class="text-center no-margin text-capitalize" style="font-size: 12px">
                          {{ colorSkin }}
                        </p>
                      </li>
                    </template>
                  </ul>
                </div>
                <div class="tab-pane" id="light_theme">
                  <ul class="list-unstyled clearfix">
                    <template v-for="colorSkin in colorSkins">
                      <li style="float:left; width: 50%; height:auto; padding: 5px;">
                        <a tabindex="-1" href="javascript:void(0);" :data-skin="'skin-'+colorSkin+'-light'" style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix   full-opacity-hover">
                          <div>
                            <span style="display:block; width: 20%; float: left; height: 10px;" :class="'bg-'+colorSkin+'-active'"></span>
                            <span :class="'bg-'+colorSkin" style="display:block; width: 80%; float: left; height: 10px;"></span>
                          </div>
                          <div>
                            <span style="display:block; width: 20%; float: left; height: 35px;" :style="{ background: colorLeftSidebarLight }"></span>
                            <span style="display:block; width: 80%; float: left; height: 35px;" :style="{ background: colorBodySidebarLight }"></span>
                          </div>
                        </a>
                        <p class="text-center no-margin text-capitalize" style="font-size: 12px">{{ colorSkin }}</p>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
    <div class="control-sidebar-bg"></div>
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'
import moment from 'moment'

export default {
  name: 'dash-controlsidebar',
  data () {
    return {
      descLang: ['English', 'Thai'],
      // colorSkins: ['blue', 'teal', 'aqua', 'olive', 'green', 'purple', 'fuchsia', 'maroon', 'red', 'orange', 'yellow', 'gold', 'brown', 'black', 'navy'],
      colorSkins: ['blue', 'green', 'orange', 'red', 'purple', 'black'],
      colorLeftSidebarDark: '#222d32',
      colorBodySidebarDark: '#f4f5f7',
      colorLeftSidebarLight: '#f9fafc',
      colorBodySidebarLight: '#f4f5f7',
      logoutLabel: constLabels('logout')
    }
  },
  props: ['nowLang', 'allLang', 'focusLang', 'setLang', 'postLogout', 'controlsidebarDisp', 'toggleControlsidebar', 'postControlsidebarMailLang', 'mailLang'],
  created () {
    let _this = this
    setInterval(function () {
      _this.date = moment().format('DD/MM/YYYY')
      _this.time = moment().format('HH:mm:ss')
    }, 1000)
  },
  computed: {
    controlsidebarOpen () {
      this.logoutLabel = constLabels('logout')
      if (this.controlsidebarDisp) {
        return 'control-sidebar-open'
      } else {
        return ''
      }
    }
  },
  methods: {
    switchLang (lang) {
      this.toggleControlsidebar(true)
      this.setLang(lang)
      window.location.reload()
    },
    setMailLang (lang) {
      this.mailLang = lang
      this.postControlsidebarMailLang(lang)
    },
    focusMailLang (value) {
      console.log(value, this.mailLang)
      var focus = (value === this.mailLang) ? '_focus' : ''
      return value + focus
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashControlsidebar.vue?e75b8fe8